var render = function render(){var _vm=this,_c=_vm._self._c;return _c(this.$route.name === 'Login' ? 'layout-blank' : (this.$route.name === 'CleanChat' ? 'layout-chat': 'layout-content'),{tag:"component"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }